import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { LoaderService } from '@core/services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  template: `
    @if (isLoading()) {
      <div class="loader__overlay">
        <svg viewBox="0 0 136.3 80.9" class="loader__icon" [style.color]="primaryColor()">
          <path
            class="loader__icon-background"
            d="M111.7 30.9c10 .7 17.7 5.2 22 14.1 8 16.4-3.6 35.5-22 35.7-31.5.3-63 .2-94.6 0C7.5 80.7.2 73.3 0 63.9-.2 54.1 6.5 47 16.5 46c1.1-.1 2.5-1.2 3-2.3a26.7 26.7 0 0 1 23.2-16.5c2.3-.2 3-1.1 3.6-3.2a33.2 33.2 0 0 1 64.6 3.3l.8 3.6z"
          />
          <path
            class="loader__icon-foreground"
            d="M111.7 30.9c10 .7 17.7 5.2 22 14.1 8 16.4-3.6 35.5-22 35.7-31.5.3-63 .2-94.6 0C7.5 80.7.2 73.3 0 63.9-.2 54.1 6.5 47 16.5 46c1.1-.1 2.5-1.2 3-2.3a26.7 26.7 0 0 1 23.2-16.5c2.3-.2 3-1.1 3.6-3.2a33.2 33.2 0 0 1 64.6 3.3l.8 3.6z"
          />
        </svg>
        <div class="loader__text">{{ message() }}</div>
      </div>
    }
  `,
  styles: [
    `
      .loader__overlay {
        position: fixed;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 10000;
        animation: loader-fade-in 0.3s ease-out;
      }

      .loader__icon {
        width: clamp(300px, 25vw, 200px);
        overflow: visible;
      }

      .loader__icon-background {
        fill: none;
        stroke: white;
        stroke-width: 5;
      }

      .loader__icon-foreground {
        fill: none;
        stroke: currentColor;
        stroke-width: 3;
        stroke-dasharray: 100;
        stroke-linecap: round;
        animation: loader-stroke-animation 5s ease-in-out infinite;
      }

      .loader__text {
        color: white;
        font-size: clamp(1rem, 2.5vw, 1.5rem);
        margin-top: 1rem;
        font-weight: 500;
      }

      @keyframes loader-stroke-animation {
        0%, 100% {
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dashoffset: 500;
        }
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  private readonly loaderService = inject(LoaderService);
  readonly isLoading = this.loaderService.isLoading;
  readonly message = this.loaderService.message;
  readonly primaryColor = computed(() => {
    return '#0657a9';
  });
}
